import React, { useContext } from 'react';
import { bool, shape, string } from 'prop-types';
import {
  Button,
  Card,
  Typography
} from '@one-thd/sui-atomic-components';
import {
  StorePod,
  StorePodPhoneNumber,
  StorePodHours,
  StorePodAddress,
  StorePodMap,
  StorePodLink
} from '@thd-olt-component-react/store-pod';
import { StoreHeroContext } from '../../StoreHero.context';

const StoreHeroDetails = ({
  phoneNumbers,
  showStoreDetailsButton,
  title,
  hoursType
}) => {

  const { loading, store } = useContext(StoreHeroContext);
  const { storeDetailsPageLink } = store || {};

  const phoneNumbersMerged = { ...StoreHeroDetails.defaultProps.phoneNumbers, ...phoneNumbers };

  return (
    <div className="sui-flex sui-w-full sui-h-full">
      <Card grow PaperProps={{ className: 'sui-flex sui-size-full' }} data-component="StoreHeroDetails">
        <Typography variant="h2">{title}</Typography>
        <StorePod className="sui-grid sui-h-full" loading={loading} store={store}>
          <div className="sui-grid sui-gap-8 sui-grid-cols-2">
            <div>
              <Typography variant="body-lg">
                <span className="sui-font-w-bold">Contact Us</span>
              </Typography>
              {Object.keys(phoneNumbersMerged).map((key, index) => {
                if (phoneNumbersMerged[key]) {
                  return (
                    <div key={`${key}-${index}`} className="sui-ml-2 sui-mt-2">
                      <StorePodPhoneNumber
                        boldLabel
                        displayMultiline
                        type={key}
                      />
                    </div>
                  );
                }
                return null;
              })}
            </div>
            <div>
              <Typography variant="body-lg">
                <span className="sui-font-w-bold">Store Hours</span>
              </Typography>
              <div className="sui-grid-cols-2 sui-ml-2 sui-mt-2">
                <StorePodHours displayMultiline hoursType={hoursType} />
                <div className="sui-mt-4">
                  <StorePodHours displayMultiline hoursType="curbside" />
                </div>
              </div>
            </div>
          </div>
          <div className="sui-mt-3">
            <Typography variant="body-lg">
              <span className="sui-font-w-bold">Location</span>
            </Typography>
          </div>
          <div className="sui-grid sui-gap-8 sui-grid-cols-2">
            <div className="sui-ml-2">
              <StorePodAddress />
            </div>
            <div>
              <StorePodMap
                className="sui-items-end"
                mapOptions={{
                  height: '60',
                  width: '200'
                }}
              />
            </div>
          </div>
          <div className="sui-mt-3 sui-grid sui-gap-8 sui-grid-cols-2">
            <StorePodLink type="localAd" />
            <StorePodLink type="directions" />
          </div>
          {showStoreDetailsButton && (
            <div className="sui-mt-5">
              <Button href={storeDetailsPageLink} fullWidth>
                <span className="sui-font-w-bold">View Store Details</span>
              </Button>
            </div>
          )}
        </StorePod>
      </Card>
    </div>
  );
};

StoreHeroDetails.propTypes = {
  phoneNumbers: shape({
    services: bool,
    store: bool,
    pro: bool,
    tool: bool
  }),
  showStoreDetailsButton: bool,
  title: string,
  hoursType: string
};

StoreHeroDetails.defaultProps = {
  phoneNumbers: {
    services: false,
    store: true,
    pro: true,
    tool: true
  },
  showStoreDetailsButton: false,
  title: 'Store Details',
  hoursType: ''
};

StoreHeroDetails.displayName = 'StoreHeroDetails';

export { StoreHeroDetails };
